import { useEffect, useRef } from 'react';
import { useAdvisor } from '@/components/feature/AdvisorProvider';
import { trackContact } from '@/hooks/usePixel';

export default function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  const { wapp } = useAdvisor();

  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const scrollY = window.scrollY;
        const rect = sectionRef.current?.getBoundingClientRect();
        if (rect) {
          const offset = rect.top;
          imageRef.current.style.transform = `translateY(${offset * 0.2}px)`;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative min-h-[70vh] w-full overflow-hidden flex items-center justify-center"
    >
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <div ref={imageRef} className="absolute inset-0 w-full h-[120%] -top-[10%]">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20Latin%20American%20city%20skyline%20at%20golden%20hour%20sunset%2C%20dramatic%20clouds%20with%20warm%20golden%20and%20amber%20tones%2C%20skyscrapers%20silhouetted%20against%20colorful%20sky%2C%20panoramic%20view%2C%20cinematic%20corporate%20photography%2C%20investment%20and%20growth%20metaphor%2C%20high%20resolution%20editorial%20quality&width=1920&height=1080&seq=cta-bg-01&orientation=landscape"
            alt="Horizonte urbano Latinoamericano"
            className="w-full h-full object-cover object-top"
          />
        </div>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-aa-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-8 max-w-4xl mx-auto py-20">
        <h2 className="heading-display text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold uppercase tracking-wide mb-6">
          <span className="gold-text-gradient">Tu Proyecto</span>
          <br />
          <span className="text-white">Merece Capital</span>
        </h2>
        <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Estructuramos inversiones de escala institucional para empresarios y fondos globales.
          <br />
          Descubre si tu proyecto califica para nuestro financiamiento.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
          <a
            href={wapp}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackContact}
            className="group flex items-center gap-0 bg-aa-black border border-aa-gold rounded-full overflow-hidden hover:bg-aa-gold transition-all duration-300 hover:shadow-gold-glow"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-aa-gold text-aa-black rounded-full transition-colors group-hover:bg-aa-black group-hover:text-aa-gold">
              <i className="ri-briefcase-4-line text-lg md:text-xl" />
            </span>
            <span className="px-6 md:px-8 text-white font-semibold text-sm md:text-base uppercase tracking-wider group-hover:text-aa-black whitespace-nowrap">
              EVALÚA TU PROYECTO
            </span>
            <span className="pr-6 text-aa-gold group-hover:text-aa-black">
              <i className="ri-arrow-right-up-line text-lg" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}